import { ProLayoutProps } from '@ant-design/pro-components';
import theme from '@/theme';

const Settings: ProLayoutProps = {
  navTheme: 'light',
  layout: 'mix',
  contentWidth: 'Fixed',
  fixedHeader: true,
  fixSiderbar: true,
  splitMenus: false,
  colorWeak: false,
  siderWidth: 180,
  siderMenuType: 'group',
  colorPrimary: theme.token?.colorPrimary,
  menu: { collapsedShowGroupTitle: false },
  pageTitleRender: false,
  suppressSiderWhenMenuEmpty: false,
  disableMobile: true,
  token: {
    bgLayout: '#f5f5f5',
    header: {
      colorBgHeader: '#fff',
      heightLayoutHeader: 64,
      colorTextMenu: '#333',
      colorTextMenuSecondary: '#333',
      colorTextMenuSelected: theme.token?.colorPrimary,
      colorTextRightActionsItem: '#dfdfdf',
      colorBgMenuItemHover: 'transparent',
      colorTextMenuActive: theme.token?.colorPrimary,
    },
    sider: {
      colorTextMenu: '#666',
      colorMenuBackground: '#fff',
      colorTextMenuSelected: theme.token?.colorPrimary,
      colorBgMenuItemSelected: theme.token?.colorPrimaryBg,
    },
    pageContainer: {
      paddingBlockPageContainerContent: 16,
      paddingInlinePageContainerContent: 16,
    },
  },
  contentStyle: {
    padding: 0,
  },
};

export default Settings;
